/**
 * Shared counts for Skill Badges / Certifications tab summary chips (My Insights, Team Insights, DRI Insights).
 */

export type CertificationStatusCounts = {
  active: number;
  expiringSoon: number;
  expired: number;
};

/** Mirrors status chips in certification tables (`Active`, `Expiring Soon`, `Expired`). */
export function countCertificationMetrics(certs: unknown[] | null | undefined): CertificationStatusCounts {
  if (!certs?.length) {
    return { active: 0, expiringSoon: 0, expired: 0 };
  }
  const st = (c: unknown) => String((c as { status?: string })?.status ?? '').trim().toLowerCase();
  const active = certs.filter((c) => st(c) === 'active').length;
  const expiringSoon = certs.filter((c) => st(c).includes('expiring')).length;
  const expired = certs.filter((c) => st(c).includes('expired')).length;
  return { active, expiringSoon, expired };
}
